import * as v from 'valibot';
// =============================================================================
// Billing Schemas
// =============================================================================
export const CheckoutSchema = v.object({});
export const BillingCheckoutResponseSchema = v.object({
    checkout_url: v.string(),
    payment_id: v.string(),
});
//# sourceMappingURL=billing.js.map